import { type MeasureDataRow, DIMENSION } from '@adtrackify/at-tracking-event-types';

function asString(value: unknown): string | null {
  return typeof value === 'string' ? value : null;
}

export function getFilterValueFromRow(
  rowData: MeasureDataRow,
  dim: DIMENSION
): string | null {
  switch (dim) {
    case DIMENSION.UTM_SOURCE:
      return (
        asString(rowData.utm_source) ??
        asString(rowData[DIMENSION.UTM_SOURCE]) ??
        asString(rowData.source) ??
        asString(rowData.value)
      );
    case DIMENSION.UTM_CAMPAIGN:
      return (
        asString(rowData.mktCampaignId) ??
        asString(rowData.campaignId) ??
        asString(rowData.utm_campaign) ??
        asString(rowData[DIMENSION.UTM_CAMPAIGN]) ??
        asString(rowData.campaign) ??
        asString(rowData.value)
      );
    case DIMENSION.UTM_ADSET:
      return (
        asString(rowData.mktAdsetId) ??
        asString(rowData.adsetId) ??
        asString(rowData.utm_adset) ??
        asString(rowData[DIMENSION.UTM_ADSET]) ??
        asString(rowData.adset) ??
        asString(rowData.value)
      );
    case DIMENSION.UTM_AD:
      return (
        asString(rowData.mktAdId) ??
        asString(rowData.adId) ??
        asString(rowData.utm_ad) ??
        asString(rowData[DIMENSION.UTM_AD]) ??
        asString(rowData.ad) ??
        asString(rowData.value)
      );
    case DIMENSION.UTM_TERM:
      return (
        asString(rowData.mktAdsetId) ??
        asString(rowData.adsetId) ??
        asString(rowData.utm_term) ??
        asString(rowData[DIMENSION.UTM_TERM]) ??
        asString(rowData.term) ??
        asString(rowData.value)
      );
    case DIMENSION.UTM_CONTENT:
      return (
        asString(rowData.mktAdId) ??
        asString(rowData.adId) ??
        asString(rowData.utm_content) ??
        asString(rowData[DIMENSION.UTM_CONTENT])
      );
    case DIMENSION.UTM_MEDIUM:
      return (
        asString(rowData.utm_medium) ??
        asString(rowData[DIMENSION.UTM_MEDIUM]) ??
        asString(rowData.medium) ??
        asString(rowData.value)
      );
    default:
      return null;
  }
}

export function getCustomLabelFromRow(
  rowData: MeasureDataRow,
  dim: DIMENSION
): string | undefined {
  const str = (value: unknown): string | undefined =>
    typeof value === 'string' ? value : undefined;

  if (rowData.customLabel) return str(rowData.customLabel);

  switch (dim) {
    case DIMENSION.UTM_CAMPAIGN:
      return rowData.mktCampaignId || rowData.campaignId
        ? (str(rowData[DIMENSION.UTM_CAMPAIGN]) ?? str(rowData.campaign))
        : undefined;
    case DIMENSION.UTM_ADSET:
      return rowData.mktAdsetId
        ? (str(rowData[DIMENSION.UTM_ADSET]) ?? str(rowData.adset))
        : undefined;
    case DIMENSION.UTM_AD:
      return rowData.mktAdId || rowData.adId
        ? (str(rowData[DIMENSION.UTM_AD]) ?? str(rowData.ad))
        : undefined;
    case DIMENSION.UTM_TERM:
      return rowData.mktAdsetId || rowData.adsetId
        ? (str(rowData[DIMENSION.UTM_TERM]) ?? str(rowData.term))
        : undefined;
    case DIMENSION.UTM_CONTENT:
      return rowData.mktAdId || rowData.adId
        ? (str(rowData[DIMENSION.UTM_CONTENT]) ?? str(rowData.content))
        : undefined;
    default:
      return undefined;
  }
}
